// PATH: SaberpDeals/frontend/src/lib/dealsApi.ts
import { api } from './api';

export type DealType = 'New' | 'Upsell' | 'Renewal' | 'Support';
export type Billing = 'OneTime' | 'Recurring';

export interface Split { company: number; owner: number; sales: number; technical: number; }

export interface DealLineInput {
    catalogItemId?: number | null;
    itemName: string;
    billingType: Billing;
    qty: number;
    unitPrice: number;
    lineDiscount: number;
}
export interface AssignmentInput { personId: number; share: number; }

export interface DealInput {
    customerId: number;
    dealType: DealType;
    date: string;            // yyyy-mm-dd
    currency: 'USD' | 'IQD';
    dealDiscount: number;
    split: Split;
    lines: DealLineInput[];
    salesPeople: AssignmentInput[];
    technicalPeople: AssignmentInput[];
}

export interface DealListItem {
    id: number;
    customer: string;
    dealType: DealType;
    date: string;
    currency: string;
    total: number;
    recurringTotal: number;
}

export interface PayoutRow {
    role: 'Company' | 'Owner' | 'Sales' | 'Technical';
    personId: number | null;
    recipientName: string;
    amount: number;
    source: string;
}
export interface DealDetail {
    id: number;
    customerId: number;
    customer: string;
    dealType: DealType;
    date: string;
    currency: 'USD' | 'IQD';
    dealDiscount: number;
    split: Split;
    oneTimeTotal: number;
    recurringTotal: number;
    total: number;
    lines: { itemName: string; billingType: Billing; qty: number; unitPrice: number; lineDiscount: number; lineTotal: number; }[];
    payouts: PayoutRow[];
}

export const dealsApi = {
    async list(): Promise<DealListItem[]> {
        const { data } = await api.get('/api/deals/deals');
        return data;
    },
    async get(id: number): Promise<DealDetail> {
        const { data } = await api.get(`/api/deals/deals/${id}`);
        return data;
    },
    async defaults(dealType: DealType): Promise<Split> {
        const { data } = await api.get(`/api/deals/deals/defaults/${dealType}`);
        return data;
    },
    async create(input: DealInput): Promise<{ id: number }> {
        const { data } = await api.post('/api/deals/deals', input);
        return data;
    },
    async remove(id: number): Promise<void> {
        await api.delete(`/api/deals/deals/${id}`);
    },
};